export enum Locale {
  en = 'en',
  fr = 'fr',
}
